import {ArrowBack,Search} from "@mui/icons-material";
import {Fab} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {AppRoutes} from "../../Router";
import './Catalog.scss';
import {WLOCreditAPIService} from "../../services";
import {useEffect, useRef, useState} from "react";
import {useIntl} from "react-intl";
import ClockLoader from "react-spinners/ClockLoader";
import {useLoginContext} from "../../hooks/useLoginContext";
import {useRequestContext} from "../../hooks/useRequestContext";
import ResponsiveAppBar from "../../components/shared/Menubar/ResponsiveAppBar";
interface CatalogProps {
}

const hasValidInventory = (data: any) =>
    Boolean(data?.RespProd?.RespuestaProd && Array.isArray(data.RespProd.RespuestaProd) && data.RespProd.RespuestaProd.length > 0);

// Deduplica llamadas concurrentes idénticas (p. ej. StrictMode en desarrollo)
let inflightInventoryPromise: Promise<any> | null = null;

const fetchInventoryOnce = (data: any) => {
    if (!inflightInventoryPromise) {
        inflightInventoryPromise = WLOCreditAPIService.getInventario(data)
            .finally(() => {
                inflightInventoryPromise = null;
            });
    }
    return inflightInventoryPromise;
};

export function Catalog(_props: CatalogProps) {
    const {user} = useLoginContext();
    const {setRequest} = useRequestContext();
    const [isLoading, setIsLoading] = useState(true);
    const [valorBusqueda, setBusqueda] = useState("");
    const [inventarioWLO, setInventarioWLO] = useState(null as any);
    const [catalogo, setCatalogo] = useState([] as any);
    const intl = useIntl();
    const navigate = useNavigate();
    const inventoryRequestId = useRef(0);

    const handleSubmit = () => {
        if(user.istipo=="2"){
            navigate(AppRoutes.LOGINAUTO, {replace: true});
        }else{
            navigate(AppRoutes.MENU_USER, {replace: true});
        }
    };

    const handleSubmitCredit = (name: any, price: any, imagen:any) => {
        setRequest({nameProduct: name, priceProduct: price, searchANI: false, errorConsulta: false,imagemoto:imagen})
        navigate(AppRoutes.HOME, {replace: true});
    };

    const getInfoProductos = async (data:any, isActive?: () => boolean)=>{
        if(data.pws_cate_producto == "-1"){
            data.pws_cate_producto =""
        }
        const requestId = ++inventoryRequestId.current;
        setIsLoading(true);
        try {
            const result = await fetchInventoryOnce(data);
            if ((isActive && !isActive()) || requestId !== inventoryRequestId.current) {
                return;
            }
            const payloadData = result?.payload?.data;
            if (!hasValidInventory(payloadData)) {
                // No pisar un inventario válido previo con una respuesta fallida
                setInventarioWLO((prev: any) => hasValidInventory(prev) ? prev : null);
                return;
            }
            const productos = payloadData.RespProd.RespuestaProd;
            setCatalogo([{
                R_s_cod_cate: productos[0]?.R_s_cod_prod ?? '',
                R_s_nom_cate: productos[0]?.R_s_nom_prod ?? ''
            }]);
            setInventarioWLO(payloadData);
        } catch (error) {
            if ((isActive && !isActive()) || requestId !== inventoryRequestId.current) {
                return;
            }
            setInventarioWLO((prev: any) => hasValidInventory(prev) ? prev : null);
        } finally {
            if ((!isActive || isActive()) && requestId === inventoryRequestId.current) {
                setIsLoading(false);
            }
        }
    }

    useEffect(() => {
        let active = true;
        getInfoProductos({
            pws_tip_producto: "",
            pws_cod_producto: "",
            pws_cate_producto: ""
        }, () => active);
        return () => {
            active = false;
        };
    }, []);

    const handleSearch=async (evento:any)=>{
        setBusqueda(evento.target.value)
    }
    const searchbutton= async ()=>{
        getInfoProductos({
            pws_tip_producto: "",
            pws_cod_producto: "",
            pws_cate_producto: ""
        })
    }
    const renderInventaryLocal = () => {
        const productos = inventarioWLO?.RespProd?.RespuestaProd;
        if (isLoading) {
            return (<div>{'Cargando'}</div>);
        }
        if (!productos || !Array.isArray(productos) || productos.length === 0) {
            return (<div>{'No hay productos disponibles'}</div>);
        }
        return productos.map((valor:any, key: number)=>{
            if(valorBusqueda){
                if(valor.R_s_nom_prod.toLocaleLowerCase().includes(valorBusqueda.toLocaleLowerCase())){
                    return (
                        <>
                            <Col md={1} key={`spacer-l-${key}`}/>
                            <Col
                                md={2}
                                key={`prod-${key}`}
                                onClick={() => handleSubmitCredit(valor.R_s_nom_prod, valor.R_s_precio_comer,valor.R_s_link_img)}>
                                <img className={'img-fluid'} style={{height:"200px", borderRadius:"40px"}} src={valor.R_s_link_img} alt={''} />
                                <h1 className="title-model">{valor.R_s_nom_prod}</h1>
                            </Col>
                            <Col md={1} key={`spacer-r-${key}`}/>
                        </>
                    )
                }else{
                    return null
                }
            }else{
                return (
                    <>
                        <Col md={1} key={`spacer-l-${key}`}/>
                        <Col
                            md={2}
                            key={`prod-${key}`}
                            onClick={() => handleSubmitCredit(valor.R_s_nom_prod, valor.R_s_precio_comer,valor.R_s_link_img)}>
                            <img className={'img-fluid'}  style={{height:"200px", borderRadius:"40px"}}src={valor.R_s_link_img} alt={''}/>
                            <h1 className="title-model">{valor.R_s_nom_prod}</h1>
                        </Col>
                        <Col md={1} key={`spacer-r-${key}`}/>
                    </>
                )
            }
        })
    }

    return (

        <div>
            <ResponsiveAppBar/>
            <ClockLoader id='spinner' color={"#01A451"} loading={isLoading} size={100}/>
            <div className="flex-container-catalog">
                <div className="flex-item-left-catalog">
                    <Fab variant="extended" color="neutral" aria-label="add"
                         onClick={handleSubmit} className="hooverButtonRed">
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {intl.formatMessage({id: "button_back"})}
                    </Fab>
                </div>
                <div className="flex-item-right-catalog">
                    <h1 className="title-motos-catalog">{intl.formatMessage({id: "motorcycles"})}</h1>
                    <h3 className="subtitle-motos-catalog">{intl.formatMessage({id: "choose_the_one_of_your_preference"})}</h3>
                </div>
                <div className="flex-item-left-catalog">
                </div>
            </div>
            <Row className="flex-item-right-catalog">
                <Col md={6}>
                {/* <FormGroup>
                        <div style={{display:"flex"}}>
                            <label>Filtro de busqueda por categorias</label>
                        <Input
                            className='form-control-search-catalog'
                            id="name"
                            name="name"
                            onBlur={handleSearch}
                            placeholder={intl.formatMessage({id: "do_search_catalog"})}
                            type="select"
                        >
                            <option value="">Selecciona una categoria</option>
                            {catalogo.map((valor:any)=>{
                            return(<option value={valor.R_s_cod_cate}>{valor.R_s_nom_cate}</option>)
                        })}
                        </Input>
                                <button onClick={searchbutton} className="buttonSearch">
                            <Search />
                            </button>
                        </div>
                       
                    </FormGroup> */}
                </Col>
                <Col md={6}/>
                {renderInventaryLocal()}
            </Row>
        </div>
    )
}
